import type { GenreInfo } from "@/types/movie";

export const GENRES: GenreInfo[] = [
  {
    name: "动作",
    slug: "动作",
    icon: "ri-sword-line",
    description:
      "动作片以高强度的追逐、格斗与爆破场面为核心，节奏紧凑、视觉冲击强。这里收录了近年口碑与热度兼具的动作佳作，包含警匪、特工、极限营救等多种题材，适合想要痛快看一场的观众。",
  },
  {
    name: "科幻",
    slug: "科幻",
    description:
      "科幻片把镜头对准未来与深空，用想象力讨论技术、人性与选择。本站科幻片单覆盖硬核太空、赛博都市与近未来设定，画面规格高、世界观完整，适合喜欢沉浸式观影的你。",
  },
  {
    name: "悬疑",
    slug: "悬疑",
    description:
      "悬疑片靠线索与反转牵引观众，一层层揭开被隐藏的真相。这里的悬疑片单以严密的结构和克制的叙事见长，适合喜欢边看边推理、享受解谜快感的观众。",
  },
  {
    name: "爱情",
    slug: "爱情",
    description:
      "爱情片记录相遇、错过与重逢，把日常里的细微情绪放大。本站爱情片单涵盖都市、青春与奇幻设定，画面温柔、配乐细腻，适合在安静的夜晚慢慢看完。",
  },
  {
    name: "剧情",
    slug: "剧情",
    description:
      "剧情片以人物与情感为核心，用扎实的剧本呈现生活的复杂面貌。这里的剧情片单多为口碑之作，表演细腻、叙事沉稳，适合愿意跟着角色一起思考的观众。",
  },
  {
    name: "动画",
    slug: "动画",
    description:
      "动画片用绘画与想象构建另一个世界，老少皆宜。本站动画片单兼顾国产与海外作品，画面精致、故事温暖，适合全家一起观看或独自放松。",
  },
  {
    name: "喜剧",
    slug: "喜剧",
    description:
      "喜剧片用幽默化解生活的重量，节奏轻快、观感轻松。这里的喜剧片单以生活流与温情喜剧为主，不靠夸张桥段，也能让人笑出声。",
  },
  {
    name: "犯罪",
    slug: "犯罪",
    description:
      "犯罪片聚焦案件、动机与人性的灰色地带，叙事锋利。本站犯罪片单包含警匪追凶与心理博弈两类，情节密度高，适合喜欢强情节的观众。",
  },
  {
    name: "奇幻",
    slug: "奇幻",
    description:
      "奇幻片打开现实之外的想象空间，包含东方山海与西方秘境。这里的奇幻片单世界观完整、美术风格突出，适合想暂时离开现实两个小时的观众。",
  },
  {
    name: "战争",
    slug: "战争",
    description:
      "战争片以真实或虚构的战场为背景，讨论勇气、代价与选择。本站战争片单注重人物刻画与场面调度，既有大场面也有细腻情感。",
  },
  {
    name: "冒险",
    slug: "冒险",
    description:
      "冒险片把人物放进未知环境，用旅程推动故事。这里的冒险片单涵盖深海、沙漠、极地与星际，画面开阔，适合喜欢探索感的观众。",
  },
  {
    name: "恐怖",
    slug: "恐怖",
    description:
      "恐怖片通过氛围与未知制造压迫感，讲究节奏与留白。本站恐怖片单以心理惊悚与都市怪谈为主，建议根据自身接受程度选择观看。",
  },
];

export const REGIONS = ["全部", "国产", "欧美", "日韩", "其他"];

export const YEARS = ["全部", "2026", "2025", "2024", "2023及更早"];

export const ALL_CATEGORY = {
  name: "全部影片",
  slug: "全部",
  icon: "ri-film-line",
  description:
    "汇集本站全部影片资源，覆盖动作、科幻、悬疑、爱情、动画等多种类型。你可以在这里按地区与年份筛选，或按最新上映、播放热度、口碑评分重新排序，快速找到今晚想看的那一部。",
};

export function getCategoryInfo(type: string) {
  if (!type || type === "全部" || type === "all") {
    return { ...ALL_CATEGORY, slug: type || "全部" };
  }
  const found = GENRES.find((item) => item.name === type);
  if (found) return found;
  return {
    name: type,
    slug: type,
    icon: "ri-film-line",
    description: `这里收录了与「${type}」相关的影片，包含简介、评分、导演与主演信息，点击卡片即可查看详情。`,
  };
}

export const SORT_OPTIONS = [
  { value: "latest", label: "最新上映" },
  { value: "hot", label: "播放热度" },
  { value: "rating", label: "评分最高" },
] as const;